export const ACCESS_TOKEN_NAME = 'access_token'
export const REFRESH_TOKEN_NAME = 'refresh_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_FULL_NAME = 'fullName'
export const USER_ID = 'userId'
export const FILE_MAX_SIZE = 524288000 /* 500MB */
export const FILE_MERGE_MAX_SIZE = 524288000 /* 500MB */
export const IS_CHECK_MAX_SIZE_UPLOAD = false
export const FULL_NAME = 'full_name'
export const TIME_OTP_EXPIRED = 'time_otp_exp'
export const IS_VERIFY_OTP_WITH_MAIL = false
export const RESET_PASSWORD_REQUIRED = 'reset_password_required'
export const ACCESS_TOKEN_EXPIRED = 'access_token_exp'
export const CLIENT_ID = 'ad5a48bf5e45759b714c661af4a79227b3a7662a76a5c602a3590e35e59ad02e'
export const CLIENT_ID_NAME = 'client-id'
export const IS_VERIFY_RECAPTCHA = false
export const PROVINCE_CODE = '003'
export const PROVINCE_NAME = 'Làng Văn Hóa Đồng Mô'
export const REDIRECT_URI_NAME = 'redirect-uri'
export const CONFIG_AUTHORIZATION_CONNECT_PARTNER = true
export const LOCATION_CODE_NAME = 'location_code'
export const USER_POSITION = 'user_position'
export const NOTIFICATION_EMERGENCY = 'notification_emergency'

export const Authorities = {
  ROLE_ADMIN: 1,           /* Admin */
  ROLE_MANAGER: 2,        /* Quản lý */
  ROLE_USER: 3,        /* Người dùng */
}

export const FileType = {
  BIEN_TAP: 0,
  CHUYEN_DOI_VAN_BAN: 1,
  GHI_AM_TEP_TIN: 2,
  GHEP_TEP: 3,
}

export const ScreenHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const ActionEditor = {
  LAYOUT_SETTING: 0,
  ADD_LAYER: 1,
  EDITOR_LAYER: 2,
  PREVIEW: 3,
}


export const TypeActionFileList = {
  DELETE_LIST: 1,
  RESTART_LIST: 2,
  UPDATE_APP_LIST: 3,
  STOP_BROADCASTING: 4,
  CHECK_TEMPERATURE: 5,
  GET_STATUS: 6,
}

export const HistoryTypeList = [
  {
    key: "null",
    value: "Tất cả trạng thái"
  },
  {
    key: "0",
    value: "Đang phát"
  },
  {
    key: "1",
    value: "Đã phát"
  },
  {
    key: "2",
    value: "Phát lỗi"
  }
]

export const ScheduleDetailStatus = {
  PENDING: 0,
  PLAYING: 1,
  BROADCAST: 2,
  ERROR: 3,
  CANCEL: 4,
  COINCIDENT: 5
}
